// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"4138733f","387":"9fcb3527","427":"53663a22","629":"99f5a3b3","847":"97819c46"}[chunkId] + ".chunk.js";
};